import request from '@utils/request'

export function fetchForms(params) {
  return request({
    url: `/admin/contract/form`,
    params,
  })
}

export function fetchForm(seq) {
  return request({
    url: `/admin/contract/form/${seq || 0}`,
    method: 'get',
  })
}

export function createForm(data) {
  return request.post('/admin/contract/form', data)
}

export function updateForm(data) {
  return request.put(`/admin/contract/form/${data.seq}`, data)
}

export function deleteForm(seq) {
  return request.delete(`/admin/contract/form/${seq}`)
}

export function fetchFormDocuments(form_seq) {
  return request({
    url: `/admin/contract/form/${form_seq || 0}/document`,
  })
}

export function fetchFormDocument(form_seq, seq) {
  return request({
    url: `/admin/contract/form/${form_seq || 0}/document/${seq || 0}`,
    method: 'get',
  })
}

export function createFormDocument({ form_seq, ...data }) {
  return request.post(`/admin/contract/form/${form_seq || 0}/document/`, data)
}

export function deleteFormDocument(form_seq, seq) {
  return request.delete(`/admin/contract/form/${form_seq || 0}/document/${seq}`)
}

export function fetchDocuments(params) {
  return request({
    url: `/admin/contract/document`,
    params,
  })
}

export function fetchDocument(seq) {
  return request({
    url: `/admin/contract/document/${seq || 0}`,
    method: 'get',
  })
}

export function createDocument(data) {
  return request.post('/admin/contract/document', data)
}

export function updateDocument(data) {
  return request.put(`/admin/contract/document/${data.seq}`, data)
}

export function deleteDocument(seq) {
  return request.delete(`/admin/contract/document/${seq}`)
}

export function fetchDocumentLangs(document_seq) {
  return request({
    url: `/admin/contract/document/${document_seq || 0}/lang`,
  })
}

export function fetchDocumentLang(document_seq, seq) {
  return request({
    url: `/admin/contract/document/${document_seq || 0}/lang/${seq || 0}`,
    method: 'get',
  })
}

export function createDocumentLang({ document_seq, ...data }) {
  return request.post(
    `/admin/contract/document/${document_seq || 0}/lang/`,
    data
  )
}

export function deleteDocumentLang(document_seq, seq) {
  return request.delete(
    `/admin/contract/document/${document_seq || 0}/lang/${seq}`
  )
}

export function deleteDocumentLangFile(data) {
  return request({
    url: `/admin/contract/document/lang-file/${data.file_seq}`,
    method: 'delete',
    data,
  })
}
